module.exports = __webpack_public_path__ + "8a067f19c6a32f781b8cb971a3214629.svg";